<template>
        <div v-for="(field, key) in fields" :key="field.id" style="margin-bottom:4px;" class="flex border rounded border-gray-200 p-4 flex-col">
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="kode_kbli"
                value="Kode KBLI"
            />
            <Input
                id="kode_kbli"
                v-model="field.kode_kbli"
                type="text"
                placeholder="Kode KBLI"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="judul_kbli"
                value="Judul KBLI"
            />
            <Input
                id="judul_kbli"
                v-model="field.judul_kbli"
                type="text"
                placeholder="Judul KBLI"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
                <JetLabel
                    class="w-full"
                    for="keterangan_kbli"
                    value="Keterangan KBLI"
                />
                <Input
                    id="keterangan_kbli"
                    v-model="field.keterangan_kbli"
                    type="text"
                    placeholder="Keterangan KBLI"
                    class="mt-1 block w-full"
                />
            </div>
            <div class="field w-full px-3" >
                    <ButtonDelete type="button" @click="RemoveField(key)" ><i class="fas fa-times-circle"></i></ButtonDelete>
            </div>
        </div>
        <div class="field w-full px-3 mb-3 mt-5" >
            <ButtonAdd type="button" @click="AddField" label="Tambah" ><i class="fas fa-plus-circle"></i> Tambah</ButtonAdd>
        </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import Input from "@/Components/Input.vue";
    import ButtonAdd from "@/Components/ButtonAdd.vue";
    import ButtonDelete from "@/Components/ButtonDelete.vue";

    import JetLabel from "@/Jetstream/Label.vue";

    export default defineComponent({
        components: {
            Input,
            ButtonAdd,
            ButtonDelete,
            JetLabel
        },
        name: 'InputRepeaterKbli',
        props: {
            modelValue: {
                type: Array,
                default: () => []
            },
            old_kbli: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                fields: [{}]
            }
        },
        computed: {
            model: {
                get: function (){
                    return this.modelValue;
                },
                set: function (value) {
                    this.$emit('update:modelValue', value);
                }
            }
        },
        mounted() {
            // this.fields = Vue.util.extend([{}], this.modelValue);
            // fire.$on('reset', this.resetField);
            // this.$emit('modelValue', this.fields);
            this.fields = this.modelValue;
            // console.log(this.modelValue);
        },
        methods: {
            AddField() {
                // console.log(this.old_kbli.length);
                let jumlahdata = this.old_kbli.length + this.fields.length;
                //if max this.fields.length 2 then return
                // console.log(jumlahdata);
                 if (jumlahdata >= 2){
                    alert('Maksimal 2 KBLI');
                    return;
                 }else{
                     this.$emit('modelValue', this.fields);
                     this.fields.push({});
                 }
                // this.fields = this.modelValue;
                // console.log(this.fields.length);
            },
            RemoveField(key) {
                this.fields.splice(key, 1);
            },
            resetField() {
                this.fields = [{}];
            },

        },
    });
</script>
